import { useSelector } from "react-redux";

import { getContent } from "../redux/selectors";

function RightPanel() {
  const content = useSelector(getContent);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}

export default RightPanel;
